//import { Directive } from '@angular/core';

//@Directive({
//  selector: '[appOnlyNumber]'
//})
//export class OnlyNumberDirective {

import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Directive({
  selector: '[_OnlyNumber]'
})
export class OnlyNumberDirective {
  private decimalCounter = 0;
  private decimaldigit = false;
  private IsPass = true;
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste'
  ];

  @Input() digit = 0;
  @Input() Length: number = 18;
  @Input() decimal?= false;
  @Input() SeparatorCharacter?= '.';
  @Input() NegativeMode?= false; //คือการ กรอกติดลบได้ ถ้าเท่ากับ True
  @Input() DefaultNegative?= false; //คือการ ให้ติดลบแต่แรกเลย
  @Input() ReturnMode?= false; //คือการ Result = 0 ให้แทน Null ถ้าเท่ากับ True
  @Input() NegativeCharacter?= '-';
  @Input() CommaCharacter?= ',';
  @Input() CommaMode?= true;
  @Input() IsTransForm?= false; //คือการ Result แบบกำหนด ไม่ใส Format ถ้าเท่ากับ True
  inputElement: HTMLInputElement;

  constructor(public el: ElementRef, private _decimalPipe: DecimalPipe) {
    this.inputElement = el.nativeElement;
  }
  number = [];
  @HostListener('keypress', ['$event'])
  onKeyDown(e: KeyboardEvent) {//Step2

    let nMaxDigit: number = 0;
    if (this.digit + "") {
      nMaxDigit = parseInt(this.digit + "") - 1;//ที่ต้องลบ 1 เพราะว่าข้อมูลที่มาจะเป็นข้อมูลก่อนหน้าเสมอ
    }
    //console.log(this.digit, ":", parseInt(this.digit + ""));
    let nMaxLength: number = 0;
    let nnMaxLength: number = 0;
    if (this.Length + "") {
      nMaxLength = parseInt(this.Length + "") - 1;//ที่ต้องลบ 1 เพราะว่าข้อมูลที่มาจะเป็นข้อมูลก่อนหน้าเสมอ
    }
    let MarkText = "";
    if (window.getSelection) {
      MarkText = window.getSelection().toString();
    }

    let InputValue = this.el.nativeElement.value.replace(MarkText, '');

    let ArrNumber: any = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", this.NegativeCharacter, this.SeparatorCharacter, this.CommaCharacter];
    let IsPassFormat = true;
    if (
      this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      (e.keyCode == 65 && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.keyCode == 67 && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.keyCode == 86 && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.keyCode == 88 && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.keyCode == 65 && e.metaKey === true) || // Allow: Cmd+A (Mac)
      (e.keyCode == 67 && e.metaKey === true) || // Allow: Cmd+C (Mac)
      (e.keyCode == 86 && e.metaKey === true) || // Allow: Cmd+V (Mac)
      (e.keyCode == 88 && e.metaKey === true)  // Allow: Cmd+X (Mac)
    ) {

      // กรณีที่เข้าเงื่อนไขด้านบนระบบจะปล่อยผ่าน
      return;
    }
    else {
      if (ArrNumber.indexOf(e.key) != -1) {

        if (this.NegativeMode) {//
          if (e.key == this.NegativeCharacter) {
            //----
            if (this.inputElement.selectionStart == 0) {//เช็คว่าเป็นตำแหน่งที่ 0 ไหม
              //console.log(this.inputElement.selectionStart);
              let nCountNegative = (InputValue.match(/-/g) || []).length;
              if (nCountNegative > 0) {//เช็คว่ามีมากกว่า 0 ไหมถ้ามีระบบไม่ให้ใส่
                IsPassFormat = true;
              }
            }
            else {
              IsPassFormat = false;
            }
          }
        } else {
          if (e.key == this.NegativeCharacter) {
            //ผ่าน T ไม่ผ่าน F
            IsPassFormat = false;
          }
        }

        if (this.decimal) {//กรณีเป็น Mode Decimal
          if (InputValue) {
            if (e.key == this.SeparatorCharacter) {//ถ้า Key . 
              if (InputValue.indexOf(this.SeparatorCharacter) != -1) {//ถ้า Key . ระบบจะตรวจสอบว่ามีใน Value ไหมถ้ามีระบบจะไม่ให้กรอก
                IsPassFormat = false;
              }
            }

            //Check Length and Digit
            if (IsPassFormat) {
              //console.log("InputValue : " + InputValue);
              //console.log("COUNT ARR : " + ArrValue.length);
              //console.log(ArrValue.length > 1);
              //console.log("MAXLEN " + nMaxLength + " : LEN" + nLength);
              //console.log("MAXDIGIT " + nMaxDigit + " : LEN" + nDigit);
              //console.log(this.inputElement.selectionStart);
              var SET_VALUE = "";
              for (var i = 0; i < InputValue.length; i++) {
                if (this.inputElement.selectionStart == i) {
                  SET_VALUE += e.key;
                }
                SET_VALUE += InputValue[i] + "";

                if (i == (this.inputElement.selectionStart - 1)) {
                  SET_VALUE += e.key;
                }
              }

              let ArrValue = SET_VALUE.split(this.SeparatorCharacter);
              let nLength = ArrValue.length > 0 ? (ArrValue[0] + "").replace(this.NegativeCharacter, '').replace(/,/g, '').length : 0;
              let nDigit = ArrValue.length > 1 ? (ArrValue[1] + "").length : 0;

              // console.log(SET_VALUE);
              if (e.key == this.NegativeCharacter) {

              } else {
                if (ArrValue.length > 1) {//กรณีที่ใส่ค่ามาแต่กรอก .
                  var IS_MAXLEN = nLength == this.Length;
                  var IS_MAXDigit = nDigit == this.digit;
                  //console.log("MAXLEN" + IS_MAXLEN)
                  //console.log("MAXDigit" + IS_MAXDigit)
                  //console.log("Length" + this.Length)
                  //console.log("nLength" + nLength)
                  //console.log("this.digit" + this.digit)
                  //console.log("nDigit" + nDigit)
                  //if (IS_MAXLEN && IS_MAXDigit) {
                  //  if (e.key == this.NegativeCharacter) {
                  //  }
                  //  else {
                  //    IsPassFormat = false;
                  //  }
                  //}
                  if (parseInt(this.Length + "") < nLength || parseInt(this.digit + "") < nDigit) {
                    IsPassFormat = false;
                  }
                  else {

                  }

                  //if (nMaxLength > nLength) {//เช็ค Max มากกว่าจะเข้า IF
                  //  if (nLength == this.Length && nDigit == this.digit) {
                  //    IsPassFormat = false;
                  //  }
                  //  else {

                  //  }
                  //}
                  //else {
                  //  if (nMaxDigit == 0) {
                  //    if (nDigit == 1) {
                  //      console.log("3");
                  //      IsPassFormat = true;
                  //    }
                  //  }
                  //  else {
                  //    if (nMaxDigit < nDigit) { //เช็ค Digit
                  //      if (nDigit == this.digit) {
                  //        console.log("zz2");
                  //        IsPassFormat = false;
                  //        //if (nMaxLength < nLength) {//เช็ค Lengh
                  //        //  if (nLength == this.Length) {
                  //        //    console.log("2");
                  //        //    IsPassFormat = false;
                  //        //  } else {

                  //        //  }
                  //        //}
                  //        //else {
                  //        // 
                  //        //}
                  //      } else {

                  //      }
                  //      console.log("4");
                  //    }
                  //  }

                  //  if (nLength == 0) {
                  //    IsPassFormat = true;
                  //    console.log("5");
                  //  }
                  //}
                }
                else {
                  if (e.key == this.NegativeCharacter) {
                    IsPassFormat = true;
                  }
                  else {//กรณีที่ใส่ค่ามาแต่ไม่กรอก .
                    if (e.key == this.SeparatorCharacter) {//กรณีที่ไม่มี . มาจะยอมให้กรอก
                      // console.log("dot");
                    } else {
                      //console.log(">>> " + nMaxLength);
                      //console.log(">>>" + nLength);
                      //if (nMaxLength >= nLength) {//เช็ค Lengh

                      //}
                      //else {
                      //  IsPassFormat = false;
                      //  console.log("6");
                      //}
                      //if (nMaxDigit >= nDigit) {
                      //  console.log("7");
                      //} else {
                      //  IsPassFormat = false;
                      //  console.log("8");
                      //}
                      if (parseInt(this.Length + "") < nLength) {
                        IsPassFormat = false;
                      }
                      else {

                      }
                    }
                  }
                }
              }
            }
          }
        }
        else {//กรณีไม่เป็น Mode Decimal ห้ามกรอก .
          if (e.key == this.SeparatorCharacter) {
            IsPassFormat = false;
          }
        }
      }
      else {
        IsPassFormat = false;
      }
    }
    if (IsPassFormat) {
    }
    else {
      e.preventDefault();
    }
  }

  @HostListener('keyup', ["$event.target.value"])
  onKeyUp(value) {
    //if (!this.decimal) {
    //  return;
    //} else {
    //  this.decimalCounter = this.el.nativeElement.value.split(this.SeparatorCharacter).length - 1;
    //}
    //this.inputElement.value = this.formatNumber(value + "");
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData.getData('text/plain');
    this.pasteData(pastedInput);
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    const textData = event.dataTransfer.getData('text');
    this.inputElement.focus();
    this.pasteData(textData);
    event.preventDefault();
  }

  @HostListener("change", ["$event.target.value"])
  onchange(value) {
    this.inputElement.value = this.formatNumber(value + "");
  }

  @HostListener("focus", ["$event.target.value"])
  onfocus(value) {//Step1
    if (value) {
      this.inputElement.value = (value + "").replace(/,/g, "");
    }
  }

  @HostListener("focusout", ["$event.target.value"])
  onfocusout(value) {
    this.inputElement.value = this.formatNumber(value + "");
  }

  private pasteData(pastedContent: string): void {
    const sanitizedContent = this.sanatizeInput(pastedContent);
    const pasted = document.execCommand('insertText', false, sanitizedContent);
    if (!pasted) {
      const { selectionStart: start, selectionEnd: end } = this.inputElement;
      this.inputElement.setRangeText(sanitizedContent, start, end, 'end');
    }
  }

  private sanatizeInput(input: string): string {
    let result = '';

    if (this.NegativeMode) {
      if (this.decimal) {
        const regex = new RegExp(`[^0-9${this.SeparatorCharacter}${this.NegativeCharacter}]`, 'g');
        result = input.replace(regex, '');
      } else {
        const regex = new RegExp(`[^0-9${this.NegativeCharacter}]`, 'g');
        result = input.replace(regex, '');
      }
    }
    else {
      if (this.decimal) {
        const regex = new RegExp(`[^0-9${this.SeparatorCharacter}]`, 'g');
        result = input.replace(regex, '');
      } else {
        const regex = new RegExp(`[^0-9]`, 'g');
        result = input.replace(regex, '');
      }
    }


    const maxLength = this.inputElement.maxLength;
    if (maxLength > 0) { // the input element has maxLength limit
      const allowedLength = maxLength - this.inputElement.value.length;
      result = allowedLength > 0 ? result.substring(0, allowedLength) : '';
    }
    return result;
  }

  //private isValidDecimal(string: string): boolean {
  //  return string.split(this.SeparatorCharacter).length <= 2;
  //}

  private formatNumber(num) {

    let Result = "";
    let sValue = null;
    let j: number = 1; // ตำแหน่ง INDEX
    let point: number = 0;
    let deletes: number = 0;
    if (num != null) {
      let str = num.trim();
      for (let i = 0; i < str.length; i++) {
        this.number[i] = str.substr(i, j); //วนเก็บ number
      }
      for (let i = 0; i < str.length; i++) {
        if (this.number[i] == ".") {
          point++; //นับ .
        }
        else if (this.number[i] == "-") {
          deletes++; //นับ -
        }
        j++;
      }
    }
    if (point == 1 && deletes == 1 || point == 0 && deletes == 1 || point == 1 && deletes == 0 || point == 0 && deletes == 0) {
      sValue = (num + "").replace(/,/g, '');
      if (sValue) {
        if (sValue.length == 1) {
          if (this.decimal) {
            sValue = sValue.replace(this.SeparatorCharacter, '');
          }
          if (this.NegativeMode) {
            sValue = sValue.replace(this.NegativeCharacter, '');
          }
        } else if (sValue == "-.") {
          sValue = sValue.replace(this.SeparatorCharacter, '');
          sValue = sValue.replace(this.NegativeCharacter, '');
        }

        if (sValue) {
          let NoComma = (sValue + "").replace(/,/g, "");//ตัด Comma ออก
          let nDigit: number = parseInt(this.digit + "");
          if (nDigit > 0) {
            if (this.DefaultNegative) {
              NoComma = (sValue + "").replace(/-/g, "");//ตัด - ออก
              NoComma = "-" + NoComma;
            }
            Result = this._decimalPipe.transform(NoComma, "1." + this.digit + "-" + this.digit);//กำหนด Format
          }
          else {
            if (this.IsTransForm) {
              Result = NoComma; //กำหนด ไม่ใส Format
            }
            else if (this.CommaMode == true) {
              Result = this._decimalPipe.transform(NoComma, "1.0-0");//กำหนด Format
            }
            else {
              Result = NoComma;//ไม่ใส่ Comma
            }
          }
        } else if (this.ReturnMode) {
          Result = this._decimalPipe.transform(0, "1." + this.digit + "-" + this.digit)
        } else {
          //Result = this._decimalPipe.transform(null)
          Result = this._decimalPipe.transform("")
        }
      }
      else {
        if (this.ReturnMode) {
          Result = this._decimalPipe.transform(0, "1." + this.digit + "-" + this.digit)
        } else {
          Result = this._decimalPipe.transform("")
        }
      }
    } else {
      if (this.ReturnMode) {
        Result = this._decimalPipe.transform(0, "1." + this.digit + "-" + this.digit)
      } else {
        Result = this._decimalPipe.transform("")
      }
    }
    return Result;
  }
}
